import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Timestamp } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import throttle from 'lodash/throttle';
import { Component } from 'react';
import { AddedCaller } from '../components/addedCaller';
import { PhoneBar } from './phoneBar';
export default class PhoneForm extends Component {
    constructor(props) {
        super(props);
        this.toggleTelephonyHold = () => {
            const { telephonySetHold, onHold, csid, requesterId } = this.props;
            telephonySetHold({
                setTo: !onHold,
                csid,
                requesterId,
            });
        };
        this.muteConversation = () => {
            this.props
                .telephonySetMute({ setTo: true, csid: this.props.csid })
                .then((response) => {
                console.info('muteConversation response', response);
            })
                .catch((exception) => {
                console.warn('muteConversation exception', exception);
            });
        };
        this.unmuteConversation = () => {
            this.props
                .telephonySetMute({ setTo: false, csid: this.props.csid })
                .then((response) => {
                console.info('unmuteConversation response', response);
            })
                .catch((exception) => {
                console.warn('unmuteConversation exception', exception);
            });
        };
        this.toggleTelephonyMute = () => {
            // this.props.telephonySetMute({setTo: !this.props.muted, csid: this.props.csid})
            if (this.props.muted === true) {
                this.unmuteConversation();
            }
            else {
                this.muteConversation();
            }
        };
        this.toggleListening = () => {
            if (this.props.canListen && this.props.isListening === false) {
                this.listenConversation();
            }
            else if (this.props.canListen && this.props.isListening === true) {
                this.leaveConversation();
            }
            else {
                console.warn('toggleListening, Can not find conversation');
            }
        };
        this.listenConversation = () => {
            this.props
                .twilioConnectCall({ csid: this.props.csid, muted: true })
                .then((response) => {
                console.info('listenConversation response', response);
            })
                .catch((exception) => {
                console.warn('listenConversation exception', exception);
            });
        };
        this.leaveConversation = () => {
            this.props
                .twilioDisconnectCall({ csid: this.props.csid })
                .then((response) => {
                this.volumeHandler = null;
                console.info('leaveConversation response', response);
            })
                .catch((exception) => {
                console.warn('leaveConversation exception', exception);
            });
        };
        this.toggleRecording = () => {
            if (this.props.isCurrentlyRecording) {
                this.props.conversationPauseCallRecording({ csid: this.props.csid });
            }
            else {
                this.props.conversationResumeCallRecording({ csid: this.props.csid });
            }
        };
        this.toggleAddCallerHold = (userId, onHold) => {
            const { addCallerSetOnHoldRequest, csid } = this.props;
            addCallerSetOnHoldRequest({
                hold: !onHold,
                csid,
                userId,
            });
        };
        this.removeCallerRequest = (userId) => {
            const { addCallerRemoveCallerRequest, csid } = this.props;
            addCallerRemoveCallerRequest({
                csid,
                userId,
            });
        };
        this.state = {
            sounds: [],
            lastUpdate: 0,
            peakIn: 0,
            peakOut: 0,
        };
        this.handleVolumeUpdate = throttle(this.handleVolumeUpdate.bind(this), 200);
        this.renderCaller = this.renderCaller.bind(this);
        this.setupVolumeHandler();
    }
    componentDidUpdate() {
        this.setupVolumeHandler();
    }
    componentWillUnmount() {
        if (window.currentConnection) {
            window.currentConnection.removeListener('volume', this.handleVolumeUpdate);
        }
    }
    setupVolumeHandler() {
        if (!this.volumeHandler) {
            if (!window.currentConnection) {
                setTimeout(() => {
                    this.setupVolumeHandler();
                }, 2000);
                return;
            }
            this.volumeHandler = window.currentConnection.on('volume', this.handleVolumeUpdate);
        }
    }
    handleVolumeUpdate(inputVolume, outputVolume) {
        this.setState(({ peakOut, peakIn, sounds }) => {
            const output = peakOut ? outputVolume / peakOut : 0;
            const input = peakIn ? inputVolume / peakIn : 0;
            return {
                peakOut: outputVolume,
                peakIn: inputVolume,
                sounds: [
                    ...sounds.slice(-999),
                    {
                        input,
                        output,
                    },
                ],
            };
        });
    }
    renderCaller({ user, onHold, callState }) {
        return (_jsx(AddedCaller, { className: "added-caller", isOnHold: onHold, caller: user, onHoldToggle: () => this.toggleAddCallerHold(user.id, onHold), onEndCall: () => this.removeCallerRequest(user.id), callState: callState }, user.id));
    }
    render() {
        const { assignedAt, muted, onHold, recordingAsyncStatus, muteAsyncStatus, holdAsyncStatus, listenAsyncStatus, telephonySendDigits, recordingEnabled, isCurrentlyRecording, isAssigned, canListen, isListening, className, extraParties, } = this.props;
        const { sounds } = this.state;
        const rootClass = classnames('phone-form', className);
        return (_jsxs("div", Object.assign({ className: rootClass }, { children: [_jsx(PhoneBar, { className: "phone-form__bar", isAssigned: isAssigned, canListen: canListen, isListening: isListening, duration: _jsx(Timestamp, { counter: true, time: assignedAt }), canRecord: recordingEnabled, isRecording: isCurrentlyRecording, sounds: sounds, toggleRecording: this.toggleRecording, toggleListening: this.toggleListening, muted: muted, onHold: onHold, recordingAsyncStatus: recordingAsyncStatus, muteAsyncStatus: muteAsyncStatus, holdAsyncStatus: holdAsyncStatus, listenAsyncStatus: listenAsyncStatus, onHoldToggle: this.toggleTelephonyHold, onMuteToggle: this.toggleTelephonyMute, onDial: telephonySendDigits }), Object.values(extraParties).map(this.renderCaller)] })));
    }
}
